import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	itemMoveErrorTitle: {
		id: 'work-management-board.board.item-move-error-title',
		defaultMessage: 'Failed to move item',
		description: 'Error title informing the user attempt at moving the issue failed.',
	},
	itemMoveErrorMessage: {
		id: 'work-management-board.board.item-move-error-message',
		defaultMessage: 'Check your connection, then give it another try.',
		description: 'Error message informing the user attempt at moving the issue failed.',
	},
	columnMoveErrorTitle: {
		id: 'work-management-board.board.column-move-error-title',
		defaultMessage: 'Failed to move column.',
		description: 'Error title informing the user attempt at moving the column failed.',
	},
	columnMoveErrorMessage: {
		id: 'work-management-board.board.column-move-error-message',
		defaultMessage: 'Check your connection, then give it another try.',
		description: 'Error message informing the user attempt at moving the column failed.',
	},
});
